import { Box, Spinner, Text, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLazyGetCurrentUserQuery } from "@/store/authApi";
import { clearAuthData } from "@/utils/authUtils";
import {
  persistAuthSession,
  processSocialLoginToken,
  sanitizeNextPath,
  setStoredAuthToken,
} from "@/utils/socialAuth";

export default function SocialLoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [fetchCurrentUser] = useLazyGetCurrentUserQuery();

  useEffect(() => {
    const token = searchParams.get("token");
    const nextPath = sanitizeNextPath(searchParams.get("next"));

    const run = async () => {
      const destination = await processSocialLoginToken(token, nextPath, {
        fetchCurrentUser: () => fetchCurrentUser().unwrap(),
        persistSession: (authToken, user) => persistAuthSession(authToken, user),
        setAuthToken: setStoredAuthToken,
        clearAuth: clearAuthData,
      });

      navigate(destination, { replace: true });
    };

    void run();
  }, [fetchCurrentUser, navigate, searchParams]);

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      _dark={{ bg: "gray.900" }}
      px={4}
    >
      <VStack gap={4}>
        <Spinner size="lg" />
        <Text color="gray.600" _dark={{ color: "gray.400" }}>
          Signing you in...
        </Text>
      </VStack>
    </Box>
  );
}
